/**
 * The product's name, for everything that displays it.
 *
 * THE VALUE ITSELF LIVES IN vite.config.ts, next to `base`, and this
 * module only re-exports it. That is not indirection for its own sake:
 * `index.html` needs the same string for the browser tab and static HTML
 * cannot import TypeScript, so the one place both can be fed from is the
 * build config. Declaring it there and pushing it both ways is what
 * stops the tab title and the page heading drifting apart.
 *
 * Same rule as BASE_PATH: one declaration, and there must never be a
 * second. If you need the name somewhere new, import it from here.
 *
 * Override per build with `VITE_APP_NAME`.
 */

// Injected by Vite's `define`. Declared rather than imported because it
// is substituted at build time, not resolved at runtime.
declare const __APP_NAME__: string;
declare const __APP_VERSION__: string;

/** e.g. "SonoSkills". */
export const APP_NAME: string = __APP_NAME__;

/** Marketing version, e.g. "2.0". Not package.json's version, which
 *  tracks the code rather than what is shown to a user. */
export const APP_VERSION: string = __APP_VERSION__;

/** e.g. "SonoSkills 2.0", for the admin sidebar. */
export const APP_VERSION_LABEL = `${APP_NAME} ${APP_VERSION}`;
